var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ejs-contextmenu", {
    ref: "msOfficeConfigigurationContextMenu",
    staticClass: "lf-context-menu-options",
    attrs: {
      id: "action-msoffice-configuration-context-menu",
      items: _setup.msOfficeConfigurationContextMenuItems,
      select: _setup.onOpenMSOfficeConfigClick,
      beforeOpen: _setup.onBeforeOpenMSOfficeConfigContextMenu,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }